import '../assets/styles/preload.css';
import './app.scss';
import template from './app.html';
import { appController as controller } from './app.controller';

export var appComponent = {
  template,
  controller
};